import React from "react";

const Header = ({ children }) => {
  return (
    <>
      <header class="flex flex-1 flex-row justify-center md:justify-evenly items-center md:p-5 w-screen fixed top-0 left-0 z-20 bg-white opacity-95">
        <a href="/">
          <img src="littlelogo.svg" alt="Little Lemon" class="w-32" />
        </a>
        {children}
      </header>
    </>
  );
};

export default Header;
